import {BaseDTO} from '../../common/models/BaseDTO';

export class IssueTicketDetailsDTO extends BaseDTO {
  issueTicketDetailsId: bigint;
  narrative: string;
  narrativeDate: number;
}
